<script>
export default {
	props:{
        prolitApiKey:{required:true},
		prolitApiEndpoint:{required:true},
		baseUrl:{required:true},
	},

	data(){
		return{
			map:null,
			infowindow:null,
			userMarker:null,
			markers:{},
            markerCluster:null,
            markerBounds:null,
			directionsService:null,
			directionsDisplay:null,
			programs:[],
			current_program_id: null,
			userPosition:{
				latitude:null,
				longitude:null,
				latlng:null,
				formattedAddress:null,
				zipcode:null,
			},
			filter:{
				zipcode:null,
				miles:5,
			},
			markerIcons: {
				active: `${window.App.base_url}/images/markers/marker-active.png`,
				inactive: `${window.App.base_url}/images/markers/marker-inactive.png`,
				userInactive: `${window.App.base_url}/images/markers/user-location-marker-inactive.png`,
				userActive: `${window.App.base_url}/images/markers/user-location-marker-active.png`,
			},
		}
	},
	
	watch:{
		programs(){
			this.programs.forEach((program, key) => {
				let marker = this.buildMarker(program);
				
				this.markers[program.id] = marker;
				this.markers[program.id].website_url = this.parseWebUrl(program.website_url);
				
				this.markerBounds.extend(marker.getPosition());
				this.buildInfowindow(program.id)
					.then(infowindow => {
						marker.infowindow = infowindow;
						this.markersEventListener(marker, infowindow,program.id);
					});

			});
            this.markerCluster = new window.MarkerClusterer(this.map, this.markers,
                {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
			this.map.fitBounds(this.markerBounds);
		}
		
	},
	
	methods: {
		getPrograms(resetUserLocation) {
			this.resetMap(resetUserLocation);
			eventsBuffer.$emit('mapBusyStatus', {status:true});
			this.isMapBusy(true);
			
			let route = `${this.prolitApiEndpoint}/?zip=${this.filter.zipcode}&distance=${this.filter.miles}&api_key=${this.prolitApiKey}`;
			
			axios.post(route)
				.then(response => {
					this.isMapBusy(false);
					this.programs = response.data;
				})
				.catch(error => {
					this.isMapBusy(false);
					console.log(error)
				});

		},
		
		mapInitSetup(){
			document.addEventListener('DOMContentLoaded', e => {
				this.infowindow = new google.maps.InfoWindow({
					minWidth: 300
				});
				this.markerBounds = new google.maps.LatLngBounds();
				
				this.directionsService = new google.maps.DirectionsService;
				this.directionsDisplay = new google.maps.DirectionsRenderer({
					preserveViewport: true,
					suppressMarkers: true
				});
				
				this.map = new google.maps.Map(
					this.$el.querySelector('#map'), {
						zoom: 5,
						center: {lat: 37.8, lng: -96},
						mapTypeId: google.maps.MapTypeId.ROADMAP,
						disableDefaultUI: true
					});
				
				// navigator.geolocation
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(this.showCurrentPosition);
					// this.showCurrentPosition();
				}
			})
		},
		
		showCurrentPosition(position) {
			this.userPosition.latitude =  position.coords.latitude;// 40.714224;
			this.userPosition.longitude = position.coords.longitude; // -73.961452;
			this.userPosition.latlng = new google.maps.LatLng(
				this.userPosition.latitude,
				this.userPosition.longitude
			);
			
			this.getZipcodeFromLatLng()
				.then((zip) =>  {
					this.filter.zipcode = zip;
					this.userMarker = this.buildMarker(false);
					this.map.panTo(this.userMarker.getPosition());
					this.map.setZoom(15);
					
					this.infowindow.setContent(`<p style="color: white;width: 250px !important;">${this.userPosition.formattedAddress}</p>`);
					this.infowindow.open(this.map, this.userMarker);
					this.userMarker.infowindow = this.infowindow;
					this.markerBounds.extend(this.userMarker.getPosition());
					this.getPrograms(false);
				})
				
				.catch(error => {
					console.log(error, 'getZipCodeFromLatLng');
				});
			
		},
		
		getZipcodeFromLatLng(){
			let geocoder = new google.maps.Geocoder;
			return new Promise((resolve, reject) => {
				
				geocoder.geocode({location: this.userPosition.latlng}, (results, status) => {
					if (status === 'OK') {
						if (results[0]) {
							this.userPosition.formattedAddress = results[0].formatted_address;
							this.userPosition.zipcode = this.geoCoderExtractFromResults(results[0], 'postal_code');
							if(this.userPosition.zipcode) return resolve(this.userPosition.zipcode);
						}
						
						return reject('No results found');
					}
					
					reject('Geocoder failed due to: ' + status);
					
				});
			})
		},
		
		geoCoderExtractFromResults(results, componentType){
			let zip = null;
			
			results.address_components.forEach((component, key) => {
				if(component.hasOwnProperty('types') && component.types.indexOf(componentType) !== -1 ){
					zip =  component.short_name;
				}
			});
			return zip;
		},

		buildMarker(program){
			
			if(program){
				return new google.maps.Marker({
					map: this.map,
					title: program.organization_name,
					icon: this.markerIcons.inactive,
					animation: google.maps.Animation.DROP,
					position: new google.maps.LatLng(program.lat, program.lng),
				});
			}



            return new google.maps.Marker({
				map: this.map,
				icon: this.markerIcons.userActive,
				position: this.userPosition.latlng,
				animation: google.maps.Animation.DROP,
			});
		},
		
		buildInfowindow(programId){
			
			return new Promise(resolve => {
				let infowindow = new google.maps.InfoWindow;

				let infoWindowContent = '<div class="info-window-container">'
				if( this.markers.hasOwnProperty(programId) && this.markers[programId].website_url ) {
					infoWindowContent += `
					
						<a role="button" class="btn btn-outline-light btn-lg btn-block mb-3" target="_blank"
						data-marker-id="${programId}"
						href="${(this.markers.hasOwnProperty(programId) && this.markers[programId].website_url)
							? this.markers[programId].website_url.toLowerCase()
							: 'javascript:;'}"
						>
							<span>See Website</span>
							<i class="fas fa-angle-right"></i>
						</a>`;
				}
					infoWindowContent +=`
                        <button type="button" class="btn btn-outline-light btn-lg btn-block mb-3 infowindow-btn-directions"
						data-marker-id="${programId}">
							<span>Get directions</span>
							<i class="fas fa-angle-right"></i>
						</button>
					</div>
				    `;


				infowindow.setContent(infoWindowContent);
				resolve(infowindow);
			})
		},
		
		markersEventListener(marker, infowindow, $markerId){
			let vm = this;

			marker.addListener('click', () => {
				infowindow.open(this.map, marker);
				this.map.setCenter(marker.getPosition());
				// update sibling markers
				this.updateMarkerStatus($markerId, infowindow)
			});
			
			google.maps.event.addListener(infowindow, 'domready', () => {
				let vm = this;
				$('.infowindow-btn-directions').on('click', function(){
					let markerId = $(this).data('markerId');
					
					if(vm.markers.hasOwnProperty(markerId)){
						//let origin = null;
						let destination = `${vm.markers[markerId].position.lat()},${vm.markers[markerId].position.lng()}`;
						let directionLink = `//maps.google.com/?saddr=Current+Location&daddr=${destination}`;
						win = window.open(directionLink, '_blank');
						win.focus();
						//return vm.thisGetDirections(markerId);
					}


				});
			});
		},
		
		thisGetDirections(markerId){
			let origin = this.markers[markerId];
			this.directionsDisplay.setMap(null);
			this.directionsDisplay.setMap(this.map);
			
			this.directionsService.route({
				origin: origin.getPosition(),
				destination: this.userMarker.getPosition(),
				travelMode: 'DRIVING'
			}, (response, status) => {
				if (status === 'OK') {
					this.directionsDisplay.setDirections(response);
					origin.infowindow.close();
				}else{
					window.alert('Directions request failed due to ' + status);
				}
			});
		},
		
		updateMarkerStatus(currentMarkerId){
			Object.keys(this.markers).forEach((markerId) => {
				if( markerId === currentMarkerId){
					return this.markers[markerId].setIcon(this.markerIcons.active);
				}
				
				if(this.markers[markerId].infowindow) this.markers[markerId].infowindow.close();
				
				if(this.userMarker){
					this.userMarker.infowindow.close();
					this.userMarker.setIcon(this.markerIcons.userInactive);
				}
				return this.markers[markerId].setIcon(this.markerIcons.inactive);
			})
		},
		
		resetMap(resetUserMarker){

			this.markerBounds = new google.maps.LatLngBounds();
			
			Object.keys(this.markers).forEach(markerId => {
				if(this.markers.hasOwnProperty(markerId)) this.markers[markerId].setMap(null);
			});
			
			if(resetUserMarker !== false && this.userMarker ) this.userMarker.setMap(null);
		},
		
		parseWebUrl(website){
			if(!website) return null;
			
			if(website.indexOf('://') === -1){
				return `http://${website}`;
			}
			return website
			
			
		},
		
		showMarkerInfowindow(data){
			if(!this.markers.hasOwnProperty(data.markerId)) return null;
			this.current_program_id = data.markerId
			this.updateMarkerStatus(data.markerId);
			this.markers[data.markerId].infowindow.open(this.map, this.markers[data.markerId]);
		},
		
		isMapBusy($status){
			eventsBuffer.$emit('mapBusyStatus', {status:$status});
		},
	},
	
	mounted(){
		this.mapInitSetup();

		eventsBuffer.$on('displayInfowindow', this.showMarkerInfowindow)
	},

}
</script>

<template>
	<div class="container-fluid pl-0 pr-0">
		<div class="row no-gutters">
			<div class="col-4">
				<div class="filter">
					<form class="form-inline">
						<div class="col-6 align-items-start first-item">
							<label class="">Search by Zip Code</label>
							<input type="text" class="form-control" v-model="filter.zipcode">
						</div>
						<div class="col-4 align-items-start second-item">
							<label class="">Within</label>
							
							<select class="form-control" v-model="filter.miles">
								<option value="5">5 miles</option>
								<option value="10">10 miles</option>
								<option value="15">15 miles</option>
								<option value="20">20 miles</option>
								<option value="25">25 miles</option>
							</select>
						</div>
						<div class="col-2 align-items-start third-item">
							<button class="submit" @click.prevent="getPrograms">
								<i class="fas fa-search"></i>
							</button>
						</div>
					</form>
				</div>
				<div class="results-alert">
					<template v-if="!programs.length">
						no programs were found.
					</template>
					
					<template v-else>
						We found <strong> {{ programs.length }}</strong> results for you
					</template>
				</div>
				<div class="results">
					
					<ul>
						<li v-if="!programs.length">
							No programs available.
						</li>
						
						<template v-else>
							<near-programs-results 
							v-for="program in programs"  
							:key="program.id" 
							:ref="'program-' + program.id"
							:active="current_program_id===program.id"
	                        :program="program">
							</near-programs-results>
						</template>
						
					</ul>
				</div>
			
			</div>
			<div class="col-8">
				<div style="height: 88%" id="map" class="map"></div>
				
				<div class="sources d-flex justify-content-center align-content-center">
                    <span class="">Sources:</span>
                    <img class="" src="/images/national-literacy-directory.png" />
                    <img class="" src="/images/dollar-general.png" />
                    <img class="" src="/images/ncf.png" />
                </div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.user-marker{
		color: white;
		width: 250px !important;
	}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/pages/near-programs-map.vue